$(document).ready(function () {
	
	// Change-Event for Number in index of wako
	$("#shoppingcart").on("change",".wl-input", function(e) {
		$("button[name='wako_btn_submit_recalculate']").click();
	});

	$("#shoppingcart").on("click", ".wako_del", function (e) {
		var form	= $(this).closest("form");
		var id		= $(this).attr("id").replace("wako_del_","");
		$("input[name=wako_anzahl_" + id +"]").val("0");
		$("button[name=wako_btn_submit_recalculate]").click();
	});

	$("input[name=rechnungsadresse_ist_lieferadresse]").change(function (){
		if ($("input[name='rechnungsadresse_ist_lieferadresse']:checked").val() == '1') {
			$("#wako_form_lieferadresse").hide();
		} else {
			$("#wako_form_lieferadresse").show();
		}
	});

	$(".payment").on("click",function( ){
		$(".payment").removeClass("active");
		$(this).addClass("active");
		$("#wako_bezahltyp").val( $(this).attr("data-id") );
	});
});

// Warenkorb hinzufuegen Funktion
function warenkorb_add(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_add_artikel.html'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				// Find All Wako Counters
				window.parent.$('.wako_count').each(function() {
					if (window.parent.$(this).length > 0) {
						window.parent.$(this).html($('basket_count', xml).text());
					}
				});
				window.parent.update_wakobox_and_show();
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

//Warenkorb loeschen Funktion
function warenkorb_delete(artikel_id,artikel_typ,sprache) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_delete_artikel'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				window.parent.update_wakobox_and_show(sprache);
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht gelöscht werden.");
		}
	});
}

function open_overlay(element){
	$("#" + element + "_overlay").show();
}

function close_overlay(element){
	$("#" + element + "_overlay").hide();
}

// Warenkorb Overlay updaten und anzeigen
function update_wakobox_and_show() {
	$.ajax({
		url: '/warenkorb/ajax_shopping_cart.html',
		type: "POST",
		success: function(html,textStatus){
			$("#shopping_cart_overlay").replaceWith(html);
			$("#shopping_cart_overlay").show();
		},
		error: function(){
			alert("Beim Laden des Warenkorbs ist ein Fehler aufgetreten.")
		}
	});
}

/*
// Anzahl erneuern im Warenkorb
function recount(){
	$("button[name='wako_btn_submit_recalculate']").click();
}*/

// Toggle Lieferadresse
function toggle_lieferadresse() {
	if ($("input[name='rechnungsadresse_ist_lieferadresse']:checked").val() == '1') {
		$("#wako-form-lieferadresse").hide();
	} else {
		$("#wako-form-lieferadresse").show();
	}
}